<script>
  import Icon from "@iconify/svelte";
  import { locale, setLocale, SUPPORTED } from "../lib/i18n";

  const FLAGS = {
    en: "circle-flags:us",
    fr: "circle-flags:fr",
    es: "circle-flags:es",
    pt: "circle-flags:pt",
  };

  const LABELS = { en: "English", fr: "Français", es: "Español", pt: "Português" };

  let open = $state(false);

  function select(code) {
    setLocale(code);
    open = false;
  }
</script>

<div class="relative" role="group">
  <button
    type="button"
    class="inline-flex h-10 items-center justify-center gap-1.5 rounded-lg border border-white/10 bg-black px-2.5 text-sm text-neutral-200 transition-colors hover:bg-zinc-950"
    onclick={() => (open = !open)}
    onblur={() => setTimeout(() => (open = false), 150)}
    aria-haspopup="listbox"
    aria-expanded={open}
    aria-label="Language"
    title="Language"
  >
    <Icon icon={FLAGS[$locale] || FLAGS.en} class="h-5 w-5 rounded-full" />
    <span class="hidden sm:inline text-xs uppercase text-neutral-400">{$locale}</span>
    <Icon icon="mdi:chevron-down" class="h-4 w-4 text-neutral-500 transition-transform {open ? 'rotate-180' : ''}" />
  </button>

  {#if open}
    <ul
      class="absolute right-0 top-full mt-1.5 min-w-[150px] overflow-hidden rounded-lg border border-white/10 bg-black py-1 shadow-xl shadow-black/50 z-[60]"
      role="listbox"
    >
      {#each SUPPORTED as code}
        <li role="option" aria-selected={$locale === code}>
          <button
            type="button"
            class="flex items-center gap-2 w-full px-3 py-2 text-left text-sm {$locale === code ? 'bg-white/[0.10] text-white' : 'text-neutral-300 hover:bg-white/[0.06] hover:text-white'}"
            onclick={() => select(code)}
          >
            <Icon icon={FLAGS[code]} class="h-5 w-5 rounded-full shrink-0" />
            <span>{LABELS[code]}</span>
          </button>
        </li>
      {/each}
    </ul>
  {/if}
</div>
